<template>
    <div class="index-layout" id="wrapper"
         :class="{toggled : sideNavHidden}"
    >
        <master-list-side-nav style="min-height: calc(100% - 113px)" v-if="!isHidden"></master-list-side-nav>
        <router-view :class="{'w-100p' : sideNavHidden}" id="page-content-wrapper"></router-view>
    </div>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex';
    import MasterListSideNav from "../../components/sub_components/master_lists/MasterListSideNav";
    import { vueAppMixin } from "../../mixins/vueAppMixin";

    export default {
        name: "MasterListIndex",
        mixins: [ 'vueAppMixin' ],
        data() {
            return {
                isHidden: false
            }
        },

        computed: {
            ...mapGetters([ 'sideNavHidden' ])
        },

        components: {
            MasterListSideNav
        }
    }
</script>

<style scoped>

</style>
